import { render, staticRenderFns } from "./DataInputUser.vue?vue&type=template&id=5756302a&"
import script from "./DataInputUser.vue?vue&type=script&lang=js&"
export * from "./DataInputUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports